import type { TranslateService } from '@ngx-translate/core';
import type { SelectItem } from '@sb/ui/select';

import type { FieldType } from './ai-template-builder/models/ai-template-builder.model';

export function fieldTypeOptions(translate: TranslateService): SelectItem<FieldType>[] {
  return [
    { value: 'date', text: translate.instant('Date') },
    { value: 'decimal', text: translate.instant('Decimal') },
    { value: 'email', text: translate.instant('Email') },
    { value: 'phone', text: translate.instant('Phone') },
    { value: 'select', text: translate.instant('Select') },
    { value: 'text', text: translate.instant('Text') },
  ];
}
